<template>
  <section class="quick-quote-info">
    <div class="table">
      <div class="tr th">
        <span>Item</span>
        <span>Information</span>
      </div>
      <div class="tr">
        <span>Position / Duties</span>
        <span>{{ getAllOptionName21('duties', quoteForm.duty_id) }}</span>
      </div>
      <div class="tr">
        <span>Nationality</span>
        <span>{{ getAllOptionName21('nationality_show', quoteForm.nationality_id) }}</span>
      </div>
      <div class="tr">
        <span>Monthly Salary</span>
        <span v-if="quoteForm.copy == 1">
          {{ quoteForm.monthly_salary | formatMoney(2, true) }}
        </span>
        <span v-else>{{ quoteForm.monthly_salary |formatMoney(2, true) }}</span>
        <!--        <span v-else>{{ getOptionName('', quoteForm.monthly_salary, salaryOptions) }}</span>-->
      </div>
    </div>
    <div class="table">
      <div class="tr th">
        <span>Item</span>
        <span>Information</span>
      </div>
      <div class="tr">
        <span>Employment Nature</span>
        <span>{{ getAllOptionName21('nature', quoteForm.nature) }}</span>
      </div>
      <!-- <div class="tr">
        <span>Date of Birth</span>
        <span>{{ quoteForm.domestic_dob }}</span>
      </div> -->
      <div
        v-if="quoteForm.period_of_cvr"
        class="tr">
        <span>Period of Insurance</span>
        <span>{{ getAllOptionName21('period', quoteForm.period_of_cvr) }}</span>
      </div>
    </div>
  </section>
</template>
<script>
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'
export default {
  name: 'HousemaidQuickQuoteInfo',
  mixins: [MixinOptions, MixinFormat],
  props: {
    quoteForm: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {

    }
  },
  computed: {
    localAllOptions() {
      return this.allOptions21
    },
    isDoula() {
      const { duty_id } = this.quoteForm
      const data = this.getOptionData('', duty_id, this.localAllOptions.duties)
      const { doula } = data || {}
      return doula === 1
    },
    salaryOptions() {
      const { salary } = this.localAllOptions
      const { doula = [], others = [] } = salary || {}
      if(this.isDoula) {
        return doula
      }
      return others
    },
  }
}
</script>
<style lang="scss" scoped>
.quick-quote-info {
    display: flex;
    justify-content: space-between;
    .table {
        width: calc(50% - 10px);
    }
}
</style>
